<template>
	<div class="form-elements">
		<div class="row">
			<div class="col-md-12">
				<vuestic-widget headerText="Relatório de Aulas por Aluno">
					<div class="row">
						<div class="col-md-6" @input="handleInputStudents">
							<model-select :options="nomesAlunos" v-model="getAluno" placeholder="Digite o nome do aluno"></model-select>
						</div>
						<div class="col-md-6">
							<button @click="searchAulasPorAluno()" class="btn btn-block btn-lg btn-secondary">Gerar Relatório</button>
						</div>
					</div>
				</vuestic-widget>

				<a href="#" hidden id="downloadRelatorioDeAulasPorAluno"></a>

				<div v-show="load">
					<div class="d-flex justify-content-center">
						<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
							<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { ModelSelect } from 'vue-search-select'
	import * as spinners from "epic-spinners"
	import urlApi from '../../router/urlApi'

	export default {
		name: "relatorioAulasPorAluno",
		components: {
			...spinners,
			ModelSelect
		},
		data() {
			return {
				load: false,
                alunos: [],
				nomesAlunos: [],
				item: {
					alunoId: '',
					alunoName: ''
				},
				getAluno: ''
			}
		},
		mounted() {
		},
		created: function() {
			const url = `${urlApi}/alunos`;
			this.$http.get(url).then((res) => {
				const dadosAlunos = res.data.dados;

				dadosAlunos.forEach((aluno) => {
					this.alunos.push({'value': aluno.id_aluno, 'text': aluno.nome});
				})
			});
		},
		methods: {
            async handleInputStudents(e) {
                const inputText = e.target.value.toLowerCase();

                this.nomesAlunos = this.alunos
                    .filter(aluno =>
                        aluno.text.toLowerCase().startsWith(inputText)
                    )
                    .slice(0, 50)
            },
			searchAulasPorAluno() {
				this.load = true;
				const idAluno = this.getAluno;

				if (!idAluno) {
					this.$toasted.show("Selecione um aluno.", {
						position: "top-right",
					});

					return this.load = false;
				}

				const url = `${urlApi}/alunos/relatorio-aulas-por-aluno/${idAluno}`;
				this.$http.get(url).then((res) => {
					var pdf = "data:application/octet-stream;base64," + res.data.dataPDF;
					var downloadPDF = document.getElementById("downloadRelatorioDeAulasPorAluno");
					downloadPDF.download = "relatorio_de_aulas_por_aluno.pdf";
					downloadPDF.href = pdf;
					downloadPDF.click();
					this.load = false;
				});
			},
			reset () {
				this.item = {}
			},
			selectFromParentComponent1 () {
				this.item = this.options[0]
			},
			reset2 () {
				this.item2 = ''
			},
			selectFromParentComponent2 () {
				this.item2 = this.options2[0].value
			}
		}
	};
</script>
